<!-- My WorkList -->
<mat-form-field class="custom-table-filter">
  <mat-label><mat-icon>filter_list</mat-icon>Filter by keyword e.g. RFQ number, RO name</mat-label>
  <input matInput (keyup)="applyFilter($event)" #input>
</mat-form-field>
<mat-spinner class="mydocs-spinner" *ngIf="isLoadingData"></mat-spinner>
<div class="mydocs-spinner-text paragraph-medium-regular" *ngIf="isLoadingData && dataSource.data.length <= 0">
  <p>Retrieving data...</p>
</div>
<app-add-reference-card [desc]="emptyMessage" *ngIf="dataSource.data.length < 1 && !isLoadingData">
</app-add-reference-card>
<div class="docs-table-container table-pe-worklist">

  <div class="table-wrapper" *ngIf="!isLoadingData && dataSource.data.length > 0">
    <table mat-table [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z8" matSort>
      <ng-container *ngFor="let column of wlColumnsToDisplay; let i = index">
        <ng-container [matColumnDef]="column" *ngIf="i == 0" sticky>
          <th mat-header-cell *matHeaderCellDef mat-sort-header tabindex="0" (keypress)="sortByColumn(column)"
            (click)="sortByColumn(column)">
            {{ formatHeader(column) }}
          </th>
          <div class="date-cell">
            <td mat-cell *matCellDef="let element">
              {{ element['NextAction'].Name }}<br />
              <app-button
              *ngIf="element['NextAction'].Action && (element['ActionId']!==1 || (element['ActionId']===1 && element['PurchaseMode']!==pageName.RFQ)) && (element['ActionId']!==2 || (element['ActionId']===2 && element['PurchaseMode']!==pageName.RFQ)) && (element['ActionId']!==2 || (element['ActionId']===2 && element['PurchaseMode']!==pageName.RFQ))"
                class="padBtn mark-done-btn" (keypress)="MarkasDone(element)" (click)="MarkasDone(element)" name="Mark as done"
                [size]="'small'"></app-button>
              <app-button
              *ngIf="element['NextAction'].Action && ((element['ActionId']===1 || element['ActionId']===2) || element['ActionId']===2) && element['PurchaseMode']===pageName.RFQ && !element.RFQSummaryNumber"
                class="padBtn mark-done-btn" (keypress)="createRFQSummary(element)" (click)="createRFQSummary(element)"
                name="Create RFQ Summary" [size]="'small'"></app-button>
              <a *ngIf="element.RFQSummaryNumber" (click)="navigateToRFQSummary(element)">{{element.RFQSummaryNumber}}</a>
            </td>
          </div>
        </ng-container>
        <ng-container [matColumnDef]="column" *ngIf="i > 0">
          <th mat-header-cell *matHeaderCellDef mat-sort-header tabindex="0" (keypress)="sortByColumn(column)"
            (click)="sortByColumn(column)">
            {{ formatHeader(column) }}
            <div class="sub-header" *ngIf="column === 'VendorNames'">
              <span class="green-circle"></span>
              <span class="text paragraph-small-regular">Quote received</span>
            </div>
          </th>
          <div class="date-cell" *ngIf="column === 'ItemDescription'">

            <!-- <td mat-cell *matCellDef="let element"  [ngClass]="{'mat-column-auto': expandedElement === element, 'mat-column': expandedElement !== element}" [tp]="element['Purpose']" 
          tpClassName="custom-tooltip" tpMaxWidth="300px" [tpInteractive]="true" tpPlacement="bottom">
            {{ element['Purpose'] }}
          </td> -->

            <td mat-cell *matCellDef="let element"
              [ngClass]="{'mat-column-auto': expandedElement === element, 'mat-column': expandedElement !== element}">
              {{ element['ItemDescription'] }}
            </td>

          </div>
          <div class="date-cell" *ngIf="column === 'RFQNumber' ">
            <td mat-cell *matCellDef="let element">
              {{ element['RFQNumber'] }}
            </td>
          </div>
          <div class="date-cell" *ngIf="column === 'RFQClosingDate'">
            <td mat-cell *matCellDef="let element">
              {{ element['RFQClosingDate'] | date : "dd/MM/yyyy" }}
            </td>
          </div>
          <div class="date-cell" *ngIf="column === 'MPDocumentNumber'">
            <td mat-cell *matCellDef="let element">
              <a (click)="getRouteToRoView(element.PurchaseMode,element.MPDocumentNumber)">{{
                element['MPDocumentNumber'] }}</a>
            </td>
          </div>
          <div class="date-cell" *ngIf="column === 'VendorNames'">
            <td mat-cell *matCellDef="let element">
              <div *ngFor="let vendor of element.VendorNames">
                <span *ngIf="vendor.Status" class="green-circle"></span>
                <span *ngIf="!vendor.Status" class="gray-circle"></span>
                <span>{{ vendor.Name.trim() }}</span>
                <br />
              </div>
            </td>
          </div>

          <div class="date-cell" *ngIf="column === 'OpenItems'">
            <td mat-cell *matCellDef="let element" [tp]="element['OpenItems']" tpClassName="custom-tooltip"
              tpMaxWidth="300px" [tpInteractive]="true" tpPlacement="bottom"
              [ngClass]="{'mat-column-auto': expandedElement === element, 'mat-column': expandedElement !== element}">
              {{ getUniqueItems(element['OpenItems']) }}
            </td>

          </div>


          <div class="date-cell" *ngIf="column === 'PurchaseMode'">
            <td mat-cell *matCellDef="let element">
              {{ element['PurchaseMode'] }}
            </td>
          </div>
          <div class="date-cell" *ngIf="column === 'ROName'">
            <td mat-cell *matCellDef="let element">
              {{ element['ROName'] }}
            </td>
          </div>

          <div class="date-cell" *ngIf="column === 'WorklistDateCreated'">
            <td mat-cell *matCellDef="let element">
              {{ element['WorklistDateCreated'] | date : "dd/MM/yyyy" }}
            </td>
          </div>
        </ng-container>

      </ng-container>

      <ng-container matColumnDef="expand" sticky>
        <th mat-header-cell *matHeaderCellDef mat-sort-header aria-label="row actions">
          &nbsp;
        </th>
        <td mat-cell *matCellDef="let element" (keypress)="toggleRowHeight(element)" (click)="toggleRowHeight(element)">
          <button mat-icon-button aria-label="expand row" (click)="toggleRowHeight(element)"
            *ngIf="((element['ItemDescription'] && element['ItemDescription'].length >= 63) || element['OpenItems'] && element['OpenItems'].length >= 63 ) ">
            <mat-icon *ngIf="expandedElement !== element">keyboard_arrow_down</mat-icon>
            <mat-icon *ngIf="expandedElement === element">keyboard_arrow_up</mat-icon>
          </button>
        </td>
      </ng-container>

      <!-- <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplayWithExpand.length">
          <div class="expansion-panel" [@detailExpand]="
              element == expandedElement ? 'expanded' : 'collapsed'
            ">
            <div class="content">
              <div class="title">
                <div>Expenditure usage:sdfsdfsdfsdf</div>
                <div>Test 111</div>
              </div>
            </div>
          </div>
        </td>
      </ng-container> -->

      <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand"></tr>
      <tr mat-row *matRowDef="let element; columns: columnsToDisplayWithExpand" class="element-row"
        [ngClass]="{'element-row-auto': expandedElement === element, 'element-row': expandedElement !== element}"
        [class.expanded-row]="expandedElement === element" tabindex="0" (keypress)="toggleRowHeight(element)"
        (click)="toggleRowHeight(element)"></tr>
      <!-- <tr
      mat-row
      *matRowDef="let row; columns: ['expandedDetail']"
      class="detail-row"
    ></tr> -->
    </table>
  </div>
  <mat-paginator [length]="totalCount" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
    [pageIndex]="currentPage" (page)="onPageChange($event)" showFirstLastButtons></mat-paginator>
</div>